module.exports = "../dist/frontend/icons/ui/thanks.svg?7a2831e2cff69c086cbf0bb0dd892a15";